<template>
  <div class="page_main">
    <div v-if="isInitialLoading" class="loading_skeleton">
      <div class="loading_top" aria-hidden="true">
        <div class="loading_kpi_group" v-for="group in 2" :key="group">
          <div class="loading_metric" v-for="metric in 4" :key="metric">
            <i class="loading_icon loading_shimmer"></i>
            <div class="loading_metric_copy">
              <i class="loading_shimmer"></i>
              <i class="loading_shimmer"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="loading_content" aria-hidden="true">
        <div class="loading_column loading_side">
          <div class="loading_panel loading_failure">
            <i class="loading_ring loading_shimmer"></i>
            <div class="loading_failure_copy">
              <i class="loading_shimmer"></i>
              <i class="loading_shimmer"></i>
              <i class="loading_shimmer"></i>
            </div>
          </div>
          <div class="loading_panel loading_ranks">
            <div class="loading_row" v-for="row in 5" :key="row">
              <i class="loading_shimmer"></i>
              <i class="loading_shimmer"></i>
            </div>
          </div>
        </div>
        <div class="loading_column loading_center">
          <div class="loading_center_title loading_shimmer"></div>
          <div class="loading_panel loading_elevators">
            <div class="loading_elevator" v-for="item in 9" :key="item">
              <i class="loading_elevator_icon loading_shimmer"></i>
              <div class="loading_elevator_copy">
                <i class="loading_shimmer"></i>
                <i class="loading_shimmer"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="loading_column loading_side">
          <div class="loading_panel loading_trend">
            <div class="loading_chart_lines">
              <i v-for="line in 5" :key="line"></i>
            </div>
          </div>
          <div class="loading_panel loading_alert">
            <i class="loading_alert_icon loading_shimmer"></i>
            <i class="loading_alert_line loading_shimmer"></i>
          </div>
        </div>
      </div>
      <div class="loading_message" role="status" aria-live="polite">
        <span class="loading_spinner" aria-hidden="true"></span>
        正在加载监控数据…
      </div>
    </div>
    <div v-else class="top_base_info">
      <div class="base_list">
        <div class="base_info">
          <img class="icon" src="@/assets/image/b1.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">维保电梯数</div>
            <div class="num">
              <div class="text">{{ formData.wbNo }}</div>
            </div>
          </div>
        </div>
        <img class="line" src="@/assets/image/base_line.png" alt="" />
        <div class="base_info">
          <img class="icon" src="@/assets/image/b2.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">物联网电梯数</div>
            <div class="num">
              <div class="text">{{ formData.iotElevators }}</div>
            </div>
          </div>
        </div>
        <img class="line" src="@/assets/image/base_line.png" alt="" />
        <div class="base_info">
          <img class="icon" src="@/assets/image/b3.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">物联网覆盖率</div>
            <div class="num">
              <div class="text">
                {{ percentage(computedForm.iotElevators, computedForm.totalElevators) }}
              </div>
              <span>%</span>
            </div>
          </div>
        </div>
        <img class="line" src="@/assets/image/base_line.png" alt="" />
        <div class="base_info">
          <img class="icon" src="@/assets/image/b4.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">物联网在线率</div>
            <div class="num">
              <div class="text">
                {{
                  percentage(formData.onlineElevators, formData.iotElevators)
                }}
              </div>
              <span>%</span>
            </div>
          </div>
        </div>
      </div>
      <div class="base_list">
        <div class="base_info">
          <img class="icon" src="@/assets/image/b5.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">本月告警次数</div>
            <div class="num">
              <div class="text">{{ formData.monthAlarmNo }}</div>
            </div>
          </div>
        </div>
        <img class="line" src="@/assets/image/base_line.png" alt="" />
        <div class="base_info">
          <img class="icon" src="@/assets/image/b6.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">本月已解决</div>
            <div class="num">
              <div class="text">{{ formData.monthSolveNo }}</div>
            </div>
          </div>
        </div>
        <img class="line" src="@/assets/image/base_line.png" alt="" />
        <div class="base_info">
          <img class="icon" src="@/assets/image/b7.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">今日告警次数</div>
            <div class="num">
              <div class="text">{{ formData.dayAlarmNo }}</div>
            </div>
          </div>
        </div>
        <img class="line" src="@/assets/image/base_line.png" alt="" />
        <div class="base_info">
          <img class="icon" src="@/assets/image/b8.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">今日已解决</div>
            <div class="num">
              <div class="text">{{ formData.daySolveNo }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isInitialLoading" class="bottom_content_box">
      <div class="left">
        <div class="failure_rate item_box">
          <div class="item_title_box">故障率</div>
          <div class="failure_rate_content">
            <div class="failure_rate_charts" id="failure_rate"></div>
            <div class="failure_rate_legend">
              <div class="legend_list">
                <img class="icon" src="@/assets/image/l1.png" alt="" />
                <img class="line" src="@/assets/image/line1.png" alt="" />
                <div class="value_box">
                  <div class="status">
                    <img class="arrow" src="@/assets/image/ar1.png" alt="" />
                    无故障电梯
                  </div>
                  <div class="value">{{ formData.notFaultNo }}</div>
                </div>
              </div>
              <div class="legend_list">
                <img class="icon" src="@/assets/image/l4.png" alt="" />
                <img class="line" src="@/assets/image/line4.png" alt="" />
                <div class="value_box">
                  <div class="status warn">
                    <img class="arrow" src="@/assets/image/ar4.png" alt="" />
                    物联网电梯
                  </div>
                  <div class="value">{{ formData.iotElevators }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="failure_five_box item_box">
          <div class="item_title_box">近30天故障电梯TOP5</div>
          <div class="five_box">
            <div class="five_head">
              <div class="sort">序号</div>
              <div class="name">项目名称</div>
              <div class="code">地址</div>
              <div class="time">故障次数</div>
            </div>
            <div class="five_list_box">
              <div class="swiper-wrapper">
                <div
                  class="five_list swiper-slide"
                  v-for="(item, index) in unitElevatorListVos"
                  :key="index"
                >
                  <div class="five_container">
                    <div class="sort">
                      <div
                        class="num"
                        :class="{ one: index == 0, two: index == 1, three: index == 2 }"
                      >
                        {{ index + 1 }}
                      </div>
                    </div>
                    <div class="name text">{{ item.faultType }}</div>
                    <div class="code text">{{ item.registrationCode }}</div>
                    <div class="time text">{{ item.count }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="center item_box">
        <div class="item_title_box other">
          电梯监控
          <div class="tags_box">
            <div class="tips_view success">
              <img class="icon" src="@/assets/image/c1.png" alt="" />
              物联在线：{{ formData.onlineElevators }}
            </div>
            <div class="tips_view">
              <img class="icon" src="@/assets/image/c2.png" alt="" />
              物联离线：{{ formData.offlineElevators }}
            </div>
            <div class="tips_view warn">
              <img class="icon" src="@/assets/image/c3.png" alt="" />
              检修：{{ formData.serviceNo }}
            </div>
            <div class="tips_view danger">
              <img class="icon" src="@/assets/image/c4.png" alt="" />
              故障：{{ formData.faultNumber }}
            </div>
            <div class="tips_view primary">
              <img class="icon" src="@/assets/image/c5.png" alt="" />
              摄像头：{{ formData.videoNo }}
            </div>
          </div>
        </div>
        <div class="ele_box">
          <!-- <div class="ele_list" v-for="(item, index) in 50" :key="index"> -->
          <div class="ele_list" v-for="(item, index) in elevatorVideoVos" :key="index">
            <div class="ele_content" :class="{ has_fault: item.faultType == 1 }">
              <div class="ele_status_row">
                <span
                  class="ele_badge"
                  :class="item.onlineType == 1 ? 'status_online' : 'status_offline'"
                >
                  <img v-if="item.onlineType == 1" src="@/assets/image/c1.png" alt="" />
                  <img v-else src="@/assets/image/c2.png" alt="" />
                  {{ item.onlineType == 1 ? "物联在线" : "物联离线" }}
                </span>
                <span v-if="item.serviceType == 1" class="ele_badge status_service">
                  <img src="@/assets/image/c3.png" alt="" />检修
                </span>
                <span v-if="item.faultType == 1" class="ele_badge status_fault">
                  <img src="@/assets/image/c4.png" alt="" />故障
                </span>
                <span class="ele_badge status_camera">
                  <img src="@/assets/image/c5.png" alt="" />摄像头
                </span>
              </div>
              <div class="ele_main">
                <img class="ele_photo" src="@/assets/image/ele_icon.png" alt="" />
                <div class="ele_info">
                  <div class="name" :title="item.elevatorName">{{ item.elevatorName }}</div>
                  <div class="order" :title="item.proveNumber">{{ item.proveNumber }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="trend_box item_box">
          <div class="item_title_box">告警趋势</div>
          <div class="trend_charts" id="trend"></div>
        </div>
        <div class="real_warn_box item_box">
          <div class="item_title_box">实时告警</div>
          <div
            class="real_content_box"
            :class="{ empty_state: realWarnList.length === 0 }"
          >
            <!-- <div class="real_list" v-for="(item, index) in 2" :key="index"> -->
            <div class="real_list" v-for="(item, index) in realWarnList" :key="index">
              <div class="real_label">
                <div class="label">{{ item.minorTypeName }}</div>
                <div class="tag" v-if="item.status == 1">未解决</div>
              </div>
              <div class="info_box">
                <div class="info_list">
                  最新告警时间：<span>{{ item.beginTime }}</span>
                </div>
                <div class="info_list">
                  注册代码：<span>{{ item.registrationCode }}</span>
                </div>
                <div class="info_list">
                  维保单位：<span>{{ item.wbDeptName }}</span>
                </div>
                <div class="info_list">
                  所属小区：<span>{{ item.communityName }}</span>
                </div>
              </div>
              <div class="picture_box">
                <div class="title">抓拍照片：</div>
                <div class="photo_list">
                  <img class="photo" :src="item.warnPic" alt="" />
                  <img class="photo" :src="item.snapPic" alt="" />
                </div>
              </div>
            </div>
            <img
              v-if="realWarnList.length == 0"
              class="nothing"
              src="@/assets/image/nothing.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import * as echarts from "echarts";
import { monitiorCenter, getDataCenter } from "@/api/user";
import { CHART } from "@/utils/theme";
export default {
  name: "MonitorCenter",
  components: {},
  data() {
    return {
      isInitialLoading: true,
      initialRequestsPending: 2,
      formData: {
        wbNo: 0,
        iotElevators: 0,
        totalElevators: 0,
        onlineElevators: 0,
        offlineElevators: 0,
        monthAlarmNo: 0,
        monthSolveNo: 0,
        dayAlarmNo: 0,
        daySolveNo: 0,
        notFaultNo: 0,
        serviceNo: 0,
        faultNumber: 0,
        videoNo: 0,
      },
      unitElevatorListVos: [],
      homeUpkeepListVos: [],
      elevatorVideoVos: [],
      url: "wss://lift.yqdiot.cn/websocket/eventMessage",
      // url: "ws://192.168.0.103:8380/websocket/eventMessage",
      webSocket: null,
      realWarnList: [],
      computedForm: {
        iotElevators: 0,
        totalElevators: 0,
      },
      socketRetryTimer: null,
      resizeHandler: null,
      failureSwiper: null,
      kpiRafId: null,
    };
  },

  mounted() {
    const query = window.location.hash.split("?")[1];
    // 解析 URL 参数
    const urlParams = new URLSearchParams(query);
    const token = urlParams.get("token");
    const code = urlParams.get("code");
    if (code) {
      console.log("App.vue 中获取的 token:", code);
      localStorage.setItem("code", code); // 或存到 Vuex
    }
    if (token) {
      console.log("App.vue 中获取的 token:", token);
      localStorage.setItem("token", token); // 或存到 Vuex
    }

    // 响应式：窗口变化时重绘 echarts
    this.resizeHandler = () => this.resizeCharts();
    window.addEventListener("resize", this.resizeHandler);
    // 响应式布局下 echarts init 时容器可能尚未 layout 完毕，
    // 延迟 300ms 强制首次 resize，防图表渲染成 0×0
    setTimeout(() => this.resizeCharts(), 300);

    this.$nextTick(() => {
      this.getData();
      if (localStorage.getItem("token")) {
        this.join();
      }
    });
  },
  destroyed() {
    this.exit();
    if (this.socketRetryTimer) {
      clearTimeout(this.socketRetryTimer);
    }
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
      this.resizeHandler = null;
    }
    if (this.failureSwiper) {
      this.failureSwiper.destroy(true, true);
      this.failureSwiper = null;
    }
    if (this.kpiRafId) {
      cancelAnimationFrame(this.kpiRafId);
      this.kpiRafId = null;
    }
  },
  methods: {
    finishInitialRequest() {
      this.initialRequestsPending = Math.max(0, this.initialRequestsPending - 1);
      if (this.initialRequestsPending === 0 && this.isInitialLoading) {
        this.isInitialLoading = false;
        this.$nextTick(() => {
          this.initFailureRate();
          this.initWarnTrend();
          this.swiperInitFive();
          this.resizeCharts();
        });
      }
    },
    resizeCharts() {
      ["trend", "failure_rate"].forEach((id) => {
        const element = document.getElementById(id);
        const chart = element && echarts.getInstanceByDom(element);
        if (chart && !chart.isDisposed()) {
          chart.resize();
        }
      });
    },
    percentage(value, total) {
      if (!Number(total)) {
        return "0.00";
      }
      return ((Number(value) || 0) / Number(total) * 100).toFixed(2);
    },
    // KPI 数字滚动动画：从 0 平滑滚到目标值（easeOutCubic 缓动）
    animateKpi(targets, duration = 1200) {
      const startTime = performance.now();
      const step = (now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        Object.keys(targets).forEach((key) => {
          this.formData[key] = Math.round(targets[key] * eased);
        });
        if (progress < 1) {
          this.kpiRafId = requestAnimationFrame(step);
        } else {
          Object.keys(targets).forEach((key) => {
            this.formData[key] = targets[key];
          });
          this.kpiRafId = null;
        }
      };
      this.kpiRafId = requestAnimationFrame(step);
    },
    join() {
      if (!localStorage.getItem("token") || this.webSocket) {
        return;
      }
      const wsuri = this.url;
      let that = this;
      this.webSocket = new WebSocket(wsuri);
      this.webSocket.onopen = function () {
        console.log("连接成功");
        that.text_content = that.text_content + "已经打开连接!" + "\n";
      };
      this.webSocket.onmessage = function (event) {
        if (that.first) {
          that.send();
          that.first = false;
        }
        //接收消息
        console.log("接收消息", event);
        that.text_content = event.data + "\n";
        //接收消息处理

        if (event.data !== "连接成功" && event.data !== "heart") {
          console.log(JSON.parse(event.data), "event.dataevent.data");

          that.realWarnList.push(JSON.parse(event.data));
          if (that.realWarnList.length > 2) {
            that.realWarnList.shift(); // 移除最前面的元素，保持最多两个
          }
          setInterval(() => {
            that.send();
          }, 10000);
        }
      };
      this.webSocket.onerror = function (error) {
        console.error("WebSocket 出错", error);
        that.exit();
        that.socketRetryTimer = setTimeout(() => {
          that.socketRetryTimer = null;
          that.join();
        }, 10000);
      };
      this.webSocket.onclose = function () {
        that.text_content = that.text_content + "已经关闭连接!" + "\n";
      };
    },
    exit() {
      if (this.webSocket) {
        this.webSocket.close();
        this.webSocket = null;
      }
    },
    send() {
      if (this.webSocket) {
        this.webSocket.send(localStorage.getItem("token"));
      } else {
        // alert("未连接到服务器");
      }
    },
    getData() {
      monitiorCenter().then((res) => {
        const data = res && res.data ? res.data : {};
        // KPI 数字滚动动画
        this.animateKpi({
          wbNo: Number(data.wbNo) || 0,
          iotElevators: Number(data.iotElevators) || 0,
          totalElevators: Number(data.totalElevators) || 0,
          onlineElevators: Number(data.onlineElevators) || 0,
          offlineElevators: Number(data.offlineElevators) || 0,
          monthAlarmNo: Number(data.monthAlarmNo) || 0,
          monthSolveNo: Number(data.monthSolveNo) || 0,
          dayAlarmNo: Number(data.dayAlarmNo) || 0,
          daySolveNo: Number(data.daySolveNo) || 0,
          notFaultNo: Number(data.notFaultNo) || 0,
          serviceNo: Number(data.serviceNo) || 0,
          faultNumber: Number(data.faultNumber) || 0,
          videoNo: Number(data.videoNo) || 0,
        });
        this.homeUpkeepListVos = data.homeUpkeepListVos || [];
        this.elevatorVideoVos = data.elevatorVideoVos || [];
        this.unitElevatorListVos = data.unitElevatorListVos || [];
      }).catch(() => {}).finally(() => {
        this.finishInitialRequest();
      });
      getDataCenter().then((res) => {
        this.computedForm = {
          ...this.computedForm,
          ...(res && res.data ? res.data : {}),
        };
      }).catch(() => {}).finally(() => {
        this.finishInitialRequest();
      });
    },
    initWarnTrend() {
      const charts = echarts.init(document.getElementById("trend"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["总告警次数", "处理告警数"],
          top: 8,
          right: 16,
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 16,
          textStyle: {
            color: "#b8c6d3",
            fontSize: 12,
          },
        },
        grid: {
          left: 42,
          right: 18,
          bottom: 22,
          top: 42,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.homeUpkeepListVos.map((item) => {
            return item.dateDay;
          }),
          axisLine: {
            lineStyle: {
              color: "rgba(137, 183, 210, 0.45)",
            },
          },
          axisLabel: {
            color: "#9fb8c9",
            fontSize: 11,
          },
        },
        yAxis: {
          type: "value",
          name: "单位: 次",
          nameTextStyle: {
            color: "#fff",
            padding: [0, 0, 0, -10],
          },
          axisLine: {
            lineStyle: {
              color: "rgba(137, 183, 210, 0.45)",
            },
          },
          axisLabel: {
            color: "#9fb8c9",
            fontSize: 11,
          },
          splitLine: {
            lineStyle: {
              color: "rgba(79, 137, 170, 0.28)",
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "总告警次数", //蓝色线
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 6,
            itemStyle: {
              color: CHART.line,
            },
            lineStyle: {
              color: CHART.line,
              width: 2,
            },
            data: this.homeUpkeepListVos.map((item) => {
              return item.upkeepNumber;
            }),
          },
          {
            name: "处理告警数", //橙色线
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 6,
            itemStyle: {
              color: CHART.lineSecondary,
            },
            lineStyle: {
              color: CHART.lineSecondary,
              width: 2,
            },
            data: this.homeUpkeepListVos.map((item) => {
              return item.doneNumber;
            }),
          },
        ],
      };
      charts.setOption(option);
    },

    initFailureRate() {
      const charts = echarts.init(document.getElementById("failure_rate"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            if (params.name === "fault") {
              return `无故障电梯：${this.formData.notFaultNo}`;
            } else {
              return `物联网电梯：${this.formData.iotElevators}`;
            }
          },
        },
        series: [
          {
            name: "故障率",
            type: "pie",
            radius: ["70%", "85%"],
            avoidLabelOverlap: true,
            label: { show: false },
            labelLine: { show: false },
            data: [
              {
                value: this.formData.notFaultNo,
                name: "fault",
                itemStyle: { color: "#00cb61" },
              },
              {
                value: this.formData.iotElevators,
                name: "normal",
                itemStyle: { color: "#3385FF" },
              },
            ],
          },
        ],
      };
      charts.setOption(option);
    },

    swiperInitFive() {
      if (this.failureSwiper) {
        this.failureSwiper.destroy(true, true);
        this.failureSwiper = null;
      }

      const slideCount = this.unitElevatorListVos.length;
      if (slideCount <= 5) {
        return;
      }

      const slidesPerView = 5;
      this.failureSwiper = new Swiper(".five_list_box", {
        slidesPerView,
        // 数据不足一页时关闭 loop，避免 Swiper 克隆数据导致排名重复显示。
        loop: slideCount > slidesPerView,
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        spaceBetween: 0,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/viewport.scss";

.page_main {
  // Keep the monitoring content aligned with the data center page below the
  // shared header tabs instead of touching the tab baseline.
  margin-top: vh(10);
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .top_base_info {
    width: 100%;
    height: vh(134);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .base_list {
      width: calc(50% - vw(10));
      height: 100%;
      background: url("@/assets/image/base_bg.png") no-repeat center;
      background-size: 100% 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      padding: 0 vw(12);
      box-sizing: border-box;
      .base_info {
        flex: 1;
        min-width: 0;
        height: vh(54);
        display: flex;
        align-items: center;
        justify-content: center;
        .icon {
          flex: 0 0 auto;
          width: vw(58);
          height: vh(44);
          object-fit: contain;
        }
        .arr {
          flex: 0 0 auto;
          margin: 0 vw(6);
          height: vh(10);
          width: vw(11);
          opacity: 0.78;
        }
        .info {
          height: 100%;
          min-width: 0;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .label {
            font-weight: 600;
            font-size: vw(14);
            color: #fff;
            white-space: nowrap;
          }
          .num {
            display: flex;
            align-items: center;
            .text {
              font-family: $font-number;
              font-weight: 700;
              line-height: vh(28);
              font-size: vw(26);
              background: linear-gradient(90deg, #00fffd 0%, #0095fa 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
            span {
              font-weight: 700;
              font-size: vw(12);
              color: #fff;
              margin-top: vh(15);
            }
          }
        }
      }
      .line {
        flex: 0 0 1px;
        width: 1px;
        height: vh(40);
      }
    }
  }
  .bottom_content_box {
    height: calc(100% - vh(149));
    width: 100%;
    display: flex;
    justify-content: space-between;
    .left {
      height: 100%;
      width: vw(480);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .failure_rate {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: calc(100% - vh(457));
        .failure_rate_content {
          background: url("@/assets/image/g1.png") no-repeat center;
          background-size: 100% 100%;
          height: vh(240);
          padding: vh(15) vw(20);
          width: vw(440);
          display: flex;
          align-items: center;
          .failure_rate_charts {
            width: 50%;
            height: 100%;
          }
          .failure_rate_legend {
            width: 50%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-evenly;
            .legend_list {
              height: vh(48);
              display: flex;
              align-items: center;
              justify-content: flex-start;
              width: 100%;
              .icon {
                width: vw(54);
                height: vh(42);
              }
              .line {
                height: vh(34);
                width: 1px;
                margin: auto vw(12);
              }
              .value_box {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: space-between;
                .status {
                  display: flex;
                  align-items: center;
                  font-weight: 400;
                  font-size: vw(14);
                  color: $color-success;
                  .arrow {
                    margin-right: vw(10);
                    width: vw(14);
                    height: vh(12);
                  }
                  &.warn {
                    color: $color-warning;
                  }
                  &.danger {
                    color: $color-danger;
                  }
                }
                .value {
                  width: auto;
                  min-width: vw(25);
                  height: vh(26);
                  font-family: $font-number;
                  font-weight: 700;
                  font-size: vw(24);
                  color: #fff;
                  line-height: vh(26);
                }
              }
            }
          }
        }
      }
      .failure_five_box {
        height: vh(442);
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .five_box {
          height: vh(370);
          width: 100%;
          padding: vh(20) 0 vh(10);
          background: url("@/assets/image/five_bg.png") no-repeat center;
          background-size: 100% 100%;
          margin: auto;
          .five_head {
            width: vw(460);
            margin: auto;
            height: 100%;
            display: flex;
            align-items: center;
            height: vh(46);
            background: #0563b0;
            div {
              text-align: center;
              font-weight: 400;
              font-size: vw(14);
              color: #fff;
            }
          }
          .five_list_box {
            height: calc(100% - vh(61));
            overflow: hidden;
            margin: vh(10) auto 0;
            width: vw(460);
            .five_list {
              width: 100%;
              height: vh(60);

              .five_container {
                background: rgba(8, 85, 150, 0.29);
                border-bottom: 1px solid rgba(66, 176, 220, 0.12);
                display: flex;
                align-items: center;
                height: vh(50);
                .text {
                  font-weight: 400;
                  font-size: vw(14);
                  color: #fff;
                  line-height: vh(18);
                  text-align: center;
                }
              }
              .num {
                width: vw(24);
                height: vw(24);
                margin: auto;
                line-height: vh(24);
                text-align: center;
                font-weight: 700;
                font-size: vw(14);
                color: #fff;
                background: linear-gradient(180deg, #74c2c0 0%, #559090 100%);

                &.one {
                  background: linear-gradient(180deg, #ff9d60 0%, #ff5900 100%);
                }
                &.two {
                  background: linear-gradient(180deg, #ffdb4f 0%, #bf9800 100%);
                }
                &.three {
                  background: linear-gradient(180deg, #546ce7 0%, #2645c1 100%);
                }
              }
            }
          }
          .sort {
            width: 15%;
          }
          .name {
            width: 30%;
          }
          .code {
            width: 35%;
          }
          .time {
            width: 20%;
          }
        }
      }
    }
    .center {
      width: calc(100% - vw(990));
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .ele_box {
        flex: 1;
        min-height: 0;
        height: auto;
        padding: vh(14) vw(8);
        box-sizing: border-box;
        background: url("@/assets/image/center_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        align-items: stretch;
        align-content: flex-start;
        flex-wrap: wrap;
        overflow-y: auto;
        .ele_list {
          width: calc(100% / 3);
          // width: 25%;
          height: vh(178);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: vh(12);
          padding: 0 vw(6);
          box-sizing: border-box;
          .ele_content {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: stretch;
            justify-content: flex-start;
            gap: vh(8);
            padding: vh(14) vw(14) vh(10);
            box-sizing: border-box;
            background: linear-gradient(135deg, rgba(2, 22, 42, 0.48), rgba(0, 92, 142, 0.22)),
              url("@/assets/image/ele_bg.png") no-repeat center;
            background-size: 100% 100%;
            position: relative;
            &.has_fault {
              background: linear-gradient(135deg, rgba(78, 25, 31, 0.38), rgba(0, 74, 119, 0.2)),
                url("@/assets/image/ele_bg.png") no-repeat center;
              background-size: 100% 100%;
              box-shadow: inset 0 0 0 1px rgba(255, 91, 82, 0.42),
                inset 3px 0 0 rgba(255, 91, 82, 0.72);
            }
            .ele_status_row {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              gap: vh(5) vw(6);
              min-height: vh(22);
              .ele_badge {
                min-height: vh(20);
                display: inline-flex;
                align-items: center;
                padding: 0 vw(7);
                box-sizing: border-box;
                border: 1px solid rgba(122, 190, 222, 0.2);
                border-radius: 2px;
                background: rgba(5, 26, 46, 0.42);
                color: #b8c6d3;
                font-size: vw(11);
                line-height: 1;
                white-space: nowrap;
                img {
                  flex: 0 0 auto;
                  width: vw(12);
                  height: vw(12);
                  margin-right: vw(4);
                  object-fit: contain;
                }
                &.status_online {
                  color: #59dfa0;
                  border-color: rgba(0, 203, 97, 0.3);
                }
                &.status_offline {
                  color: #a5bdcf;
                }
                &.status_service {
                  color: #f0c34f;
                  border-color: rgba(226, 180, 0, 0.3);
                }
                &.status_fault {
                  color: #ff766e;
                  border-color: rgba(255, 79, 67, 0.36);
                }
                &.status_camera {
                  color: #58d8ef;
                  border-color: rgba(0, 238, 255, 0.3);
                }
              }
            }
            .ele_main {
              min-width: 0;
              display: flex;
              align-items: center;
              gap: vw(14);
            }
            .ele_photo {
              flex: 0 0 auto;
              width: vw(66);
              height: vw(66);
              padding: vw(3);
              box-sizing: border-box;
              object-fit: contain;
              background: rgba(1, 17, 31, 0.28);
              border: 1px solid rgba(70, 177, 218, 0.16);
              border-radius: 2px;
            }
            .ele_info {
              flex: 1;
              min-width: 0;
              text-align: left;
            }
            .name {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              font-weight: 600;
              font-size: vw(14);
              line-height: vh(20);
              color: #fff;
            }
            .order {
              margin-top: vh(5);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-weight: 400;
              font-size: vw(12);
              color: #91b7ce;
            }
          }
        }
      }
    }
    .right {
      height: 100%;
      width: vw(480);
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .trend_box {
        height: calc(100% - vh(417));
        width: 100%;
        .trend_charts {
          background: rgba(3, 24, 42, 0.2) url("@/assets/image/rate_bg.png") no-repeat center;
          background-size: 100% 100%;
          height: calc(100% - vh(42));
        }
      }
      .real_warn_box {
        height: vh(402);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .real_content_box {
          width: calc(100% - vw(20));
          height: vh(360);
          padding: vh(20) vw(10);
          background: url("@/assets/image/five_bg.png") no-repeat center;
          background-size: 100% 100%;
          display: flex;
          justify-content: space-between;

          &.empty_state {
            align-items: center;
            justify-content: center;
          }
          .real_list {
            height: calc(100% - vh(20));
            width: vw(205);
            background: rgba(8, 85, 150, 0.29);
            padding: vh(10);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            .real_label {
              width: calc(100% - vw(20));
              height: vh(46);
              background: linear-gradient(180deg, #4c9fe4 0%, #0563b0 100%);
              padding: 0 vw(10);
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: vh(10);
              .label {
                font-weight: 700;
                font-size: vw(14);
                color: #fff;
              }
              .tag {
                background: url("@/assets/image/warn_icon.png") no-repeat center;
                background-size: 100% 100%;
                width: vw(62);
                height: vh(24);
                font-weight: 700;
                font-size: vw(12);
                color: #fff;
                text-align: center;
                line-height: vh(24);
              }
            }
            .info_box {
              .info_list {
                font-weight: 400;
                font-size: vw(12);
                color: #b8c6d3;
                text-align: left;
                line-height: vh(30);
                span {
                  font-size: vw(12);
                  color: #fff;
                }
              }
            }
            .picture_box {
              width: 100%;
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
              margin-bottom: vh(20);
              .title {
                font-weight: 400;
                font-size: vw(12);
                color: #b8c6d3;
              }
              .photo_list {
                margin-top: vh(20);
                display: flex;
                justify-content: space-between;
                .photo {
                  width: vw(96);
                  height: vh(72);
                }
              }
            }
          }
        }
      }
    }
  }
}

.item_box {
  display: flex;
  flex-direction: column;
  width: 100%;
  .item_title_box {
    width: calc(100% - vw(40));
    height: vh(36);
    background: url("@/assets/image/box_title_bg.png") no-repeat center;
    background-size: 100% 100%;
    margin-bottom: vh(6);
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    font-size: vw(24);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: vw(40);
    &.other {
      background: url("@/assets/image/center_title_bg.png") no-repeat center;
      background-size: 100% 100%;
    }
    .tags_box {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: wrap;
      gap: vh(4) vw(6);
      padding-right: vw(8);
      .tips_view {
        display: flex;
        align-items: center;
        padding: vh(2) vw(6);
        border: 1px solid rgba(120, 190, 220, 0.16);
        border-radius: 2px;
        background: rgba(2, 24, 42, 0.32);
        font-weight: 400;
        font-size: vw(12);
        color: #d6cfcd;
        font-family: Microsoft YaHei;
        white-space: nowrap;
        .icon {
          width: vw(14);
          height: vw(14);
          margin-right: vw(5);
        }
        &.success {
          color: $color-success;
        }
        &.warn {
          color: $color-warning;
        }
        &.danger {
          color: $color-danger;
        }
        &.primary {
          color: $color-info;
        }
      }
    }
  }
}
.loading_skeleton {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  .loading_shimmer {
    display: block;
    background: linear-gradient(100deg, rgba(13, 64, 94, 0.56) 25%, rgba(35, 122, 161, 0.48) 45%, rgba(13, 64, 94, 0.56) 65%);
    background-size: 220% 100%;
    animation: monitor-loading-shimmer 1.6s ease-in-out infinite;
    border-radius: 2px;
  }
  .loading_top {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: vh(134);
  }
  .loading_kpi_group {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    align-items: center;
    width: calc(50% - vw(10));
    height: 100%;
    padding: 0 vw(12);
    box-sizing: border-box;
    background: url("@/assets/image/base_bg.png") no-repeat center;
    background-size: 100% 100%;
  }
  .loading_metric {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: vw(8);
    min-width: 0;
    height: vh(54);
    border-right: 1px solid rgba(75, 174, 209, 0.18);
    &:last-child {
      border-right: 0;
    }
  }
  .loading_icon {
    flex: 0 0 auto;
    width: vw(42);
    height: vh(38);
  }
  .loading_metric_copy,
  .loading_failure_copy,
  .loading_elevator_copy {
    display: flex;
    flex-direction: column;
    gap: vh(7);
    min-width: 0;
    i {
      height: vh(8);
    }
  }
  .loading_metric_copy {
    width: vw(92);
    i:first-child {
      width: 78%;
    }
    i:last-child {
      width: 58%;
      height: vh(13);
    }
  }
  .loading_content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: calc(100% - vh(149));
    min-height: 0;
  }
  .loading_column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  .loading_side {
    width: vw(480);
  }
  .loading_center {
    width: calc(100% - vw(990));
  }
  .loading_panel {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid rgba(0, 198, 235, 0.34);
    background: linear-gradient(145deg, rgba(4, 32, 52, 0.66), rgba(4, 42, 67, 0.42));
  }
  .loading_failure {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: calc(100% - vh(457));
  }
  .loading_ring {
    width: vw(150);
    height: vw(150);
    box-sizing: border-box;
    border: vw(16) solid rgba(0, 157, 223, 0.32);
    border-top-color: rgba(0, 226, 245, 0.62);
    border-radius: 50%;
    background: transparent !important;
    animation: none !important;
  }
  .loading_failure_copy {
    width: 36%;
    i:nth-child(2) {
      width: 64%;
      height: vh(16);
    }
    i:last-child {
      width: 46%;
    }
  }
  .loading_ranks {
    display: flex;
    flex-direction: column;
    gap: vh(10);
    height: vh(442);
    padding: vh(22) vw(12);
  }
  .loading_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    padding: 0 vw(12);
    background: rgba(8, 85, 150, 0.2);
    i:first-child {
      width: 58%;
      height: vh(9);
    }
    i:last-child {
      width: 12%;
      height: vh(12);
    }
  }
  .loading_center_title {
    flex: 0 0 vh(36);
    width: calc(100% - vw(40));
    height: vh(36);
    margin-bottom: vh(6);
    background-color: rgba(12, 68, 94, 0.42);
  }
  .loading_elevators {
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-auto-rows: vh(178);
    align-content: start;
    gap: vh(12) vw(12);
    height: auto;
    padding: vh(14) vw(14);
  }
  .loading_elevator {
    display: flex;
    align-items: center;
    gap: vw(12);
    min-width: 0;
    padding: vh(10) vw(12);
    border: 1px solid rgba(70, 177, 218, 0.2);
    background: rgba(4, 44, 70, 0.5);
  }
  .loading_elevator_icon {
    flex: 0 0 auto;
    width: vw(66);
    height: vw(66);
  }
  .loading_elevator_copy {
    flex: 1;
    i:first-child {
      width: 88%;
      height: vh(11);
    }
    i:last-child {
      width: 62%;
    }
  }
  .loading_trend {
    height: calc(100% - vh(417));
    .loading_chart_lines {
      position: absolute;
      inset: 24% 8% 12%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      i {
        display: block;
        border-top: 1px dashed rgba(103, 158, 186, 0.24);
      }
    }
  }
  .loading_alert {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: vh(16);
    height: vh(402);
  }
  .loading_alert_icon {
    width: vw(98);
    height: vh(76);
    border-radius: 50%;
  }
  .loading_alert_line {
    width: vw(112);
    height: vh(10);
  }
  .loading_message {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    gap: vw(10);
    padding: vh(12) vw(18);
    transform: translate(-50%, -50%);
    border: 1px solid rgba(0, 222, 255, 0.56);
    background: rgba(3, 26, 45, 0.94);
    box-shadow: 0 0 vw(22) rgba(0, 195, 245, 0.18);
    color: #c8f5ff;
    font-size: vw(14);
    white-space: nowrap;
  }
  .loading_spinner {
    width: vw(16);
    height: vw(16);
    border: 2px solid rgba(0, 226, 245, 0.24);
    border-top-color: #00e2f5;
    border-radius: 50%;
    animation: monitor-loading-spin 0.8s linear infinite;
  }
}
@keyframes monitor-loading-shimmer {
  to {
    background-position: -220% 0;
  }
}
@keyframes monitor-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .loading_skeleton .loading_shimmer,
  .loading_skeleton .loading_spinner {
    animation: none;
  }
}
.nothing {
  display: block;
  width: 38%;
  max-width: 320px;
  max-height: 56%;
  height: auto;
  object-fit: contain;
  margin: 0 auto;
  opacity: 0.9;
}
.ele_box::-webkit-scrollbar {
  display: none; /* Chrome / Safari / Edge */
}
</style>
